/**
 * Copyright 2016 xdot GmbH
 * Author: Carsten Hibbeler
 * Date: 23.02.2016
 */
import { ClassRemoteDataStore } from 'plugin/liferay-widgets-react-web';

import { ClassNames } from '../constants/Constants';

export default class AssetTagStore extends ClassRemoteDataStore {

    constructor(Dispatcher) {
        super(Dispatcher, ClassNames.AssetTag, undefined, undefined);
    }

    reduce(state, action) {
        return super.reduce(state, action);
    }

}



// WEBPACK FOOTER //
// ./js/stores/AssetTagStore.js